import { useTranslate } from "ra-core";

// «Hopp til innhold» (PRD US21): første element i tab-rekkefølgen, synlig bare
// når det har fokus. Appen bruker hash-ruter, så en vanlig #main-content-lenke
// ville navigert; i stedet flyttes fokus til hovedfeltet.
export const SkipLink = ({
  targetId = "main-content",
}: {
  targetId?: string;
}) => {
  const translate = useTranslate();
  return (
    <a
      href={`#${targetId}`}
      onClick={(e) => {
        e.preventDefault();
        const target = document.getElementById(targetId);
        if (!target) return;
        if (!target.hasAttribute("tabindex"))
          target.setAttribute("tabindex", "-1");
        target.focus();
      }}
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:rounded-md focus:bg-background focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:shadow-lg focus:ring-2 focus:ring-ring"
    >
      {translate("crm.navigation.skip_to_content", { _: "Hopp til innhold" })}
    </a>
  );
};
